module.exports = __webpack_public_path__ + "img/map-marker-blue.938d6f14.svg";